/**
 * GET alerta de notificaciones no leídas para el usuario actual.
 */
import axiosController from "helpers/axiosController";

const GETAlertaNotificaciones = async (loggedUser, codCliente) => {
  try {
    const { token } = loggedUser;

    const response = await axiosController.get(
      `${process.env.REACT_APP_API_URL}/notificaciones/no_leidas`,
      {
        params: {
          codCliente,
        },
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      return { status: error.response.status, data: error.response.data };
    }

    if (error.request) {
      return { status: 500, message: "No se recibió respuesta del servidor" };
    }

    return { status: 400, message: "Error al realizar la solicitud" };
  }
};

export default GETAlertaNotificaciones;
